export default __webpack_public_path__ + "static/media/W.78170cf0.svg";